export const GET_GRAPH_REPORTS = 'GET_GRAPH_REPORTS';
export const GET_ME_REPORTS = 'GET_ME_REPORTS';
export const SET_PERIOD_REPORT = 'SET_PERIOD_REPORT';
